var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32287 0H1.38537C0.621437 0 0 0.621437 0 1.38537V4.94787C0 5.71194 0.621437 6.33338 1.38537 6.33338H7.32287C8.08694 6.33338 8.70838 5.71194 8.70838 4.94787V1.38537C8.70838 0.621437 8.08694 0 7.32287 0Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32287 7.91663H1.38537C0.621437 7.91663 0 8.53806 0 9.30214V17.6146C0 18.3786 0.621437 19 1.38537 19H7.32287C8.08694 19 8.70838 18.3786 8.70838 17.6146V9.30214C8.70838 8.53806 8.08694 7.91663 7.32287 7.91663Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6146 12.6666H11.6771C10.9131 12.6666 10.2916 13.2881 10.2916 14.0521V17.6146C10.2916 18.3786 10.9131 19 11.6771 19H17.6146C18.3786 19 19 18.3786 19 17.6146V14.0521C19 13.2881 18.3786 12.6666 17.6146 12.6666Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6146 0H11.6771C10.9131 0 10.2916 0.621437 10.2916 1.38537V9.69787C10.2916 10.4619 10.9131 11.0834 11.6771 11.0834H17.6146C18.3786 11.0834 19 10.4619 19 9.69787V1.38537C19 0.621437 18.3786 0 17.6146 0Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.9cb9f8461c83f4da778720ec01ac3e79.svg";
export { ForwardRef as ReactComponent };